import { useRef, useLayoutEffect } from "react";
import CB from "clipboard";
import { reportAsyncError } from "../error-reporter";

export const useClipboardText = (text: string, onCopySuccess: () => void) => {
  const buttonRef = useRef(null);

  useLayoutEffect(() => {
    const cb = new CB(buttonRef.current as any, {
      text: () => text,
    });
    cb.on("success", () => {
      onCopySuccess();
    });
    cb.on("error", (e) => {
      reportAsyncError(new Error(e.text));
    });
    return () => {
      cb.destroy();
    };
  }, [onCopySuccess, text]);
  return { buttonRef };
};
